module.exports = __webpack_public_path__ + "img/51626532_L.e73e0ea4.png";